import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  InputBase,
  Box,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  Badge,
  Paper,
  Stack,
  alpha,
  styled
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HeaderLogo from '../../Images/TaxAi_HeaderLogo.png'
import Search from '../../Components/DataGrid/Plugins/Search/Search';

// Styled Search Input Wrapper
// const Search = styled('div')(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.common.white, 0.15),
//   '&:hover': {
//     backgroundColor: alpha(theme.palette.common.white, 0.25),
//   },
//   marginRight: theme.spacing(2),
//   marginLeft: 0,
//   width: '100%',
//   [theme.breakpoints.up('sm')]: {
//     marginLeft: theme.spacing(3),
//     width: '35ch',
//   },
// }));

// const SearchIconWrapper = styled('div')(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: 'inherit',
//   width: '100%',
//   '& .MuiInputBase-input': {
//     padding: theme.spacing(1, 1, 1, 0),
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//   },
// }));

interface HeaderProps {
  onSearch: (value: string) => void;
}

const Header: React.FC<HeaderProps> = ({ onSearch }) => {
  const [filter, setFilter] = useState('allCases');
  const [selectedAccount, setSelectedAccount] = useState('1')

  return (
    <AppBar position="static" color="default" elevation={1} sx={{ bgcolor: 'white' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>

        {/* Logo */}
        {/* <Box
          component="img"
          src={HeaderLogo}
          alt="Site Logo"
          sx={{
            height: 'auto',
            width: 'auto',
          }}
        /> */}
        <Box>
          <h1>Resolution Case Dashboard</h1>
        </Box>
        {/* Search Box */}
        {/* <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <Search sx={{ border: '1px solid #e0e0e0', color: 'black' }}>
            <SearchIconWrapper>
              <SearchIcon color="action" />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search clients, Case ID.."
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search>
        </Box> */}

        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'right',
          }}
        >
          <Box
          // sx={(theme) => ({
          //   position: 'relative',
          //   // borderRadius: theme.shape.borderRadius,
          //   backgroundColor: alpha(theme.palette.common.white, 0.15),
          //   '&:hover': {
          //     backgroundColor: alpha(theme.palette.common.white, 0.25),
          //   },
          //   marginRight: theme.spacing(2),
          //   marginLeft: 0,
          //   width: '100%',
          //   border: '1px solid #e0e0e0',
          //   color: 'black',
          //   [theme.breakpoints.up('sm')]: {
          //     marginLeft: theme.spacing(3),
          //     width: '35ch',
          //   },
          // })}
          >

            <Search
              onSearch={(searchData: string) => {
                onSearch(searchData);
                // if (this.props.onSearch) {
                //     this.props.onSearch(searchData);
                // }
              }}
              searchPlaceholder="User Details"
            // defaultValue={this.props.defaultSearch}
            />

            {/* Icon Wrapper */}
            {/* <Box
              sx={(theme) => ({
                padding: theme.spacing(0, 2),
                height: '100%',
                position: 'absolute',
                pointerEvents: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })}
            >
              <SearchIcon color="action" />
            </Box> */}

            {/* Input */}
            {/* <InputBase
              placeholder="Search clients, Case ID.."
              inputProps={{ 'aria-label': 'search' }}
              onChange={(e) => onSearch(e.target.value)}
              sx={(theme) => ({
                color: 'inherit',
                width: '100%',
                '& .MuiInputBase-input': {
                  padding: theme.spacing(1, 1, 1, 0),
                  paddingLeft: `calc(1em + ${theme.spacing(4)})`,
                  transition: theme.transitions.create('width'),
                },
              })}
            /> */}
          </Box>
        </Box>

        {/* Right Section: Filter & Notifications */}
        {/* <Stack direction="row" spacing={3} alignItems="center"> */}

        {/* Filter Sub-section */}
        {/* <Stack direction="row" spacing={1} alignItems="center">
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={selectedAccount}
                onChange={(e) => setSelectedAccount(e.target.value)}
                displayEmpty
                variant="outlined"
              >
                <MenuItem value="1">Resolution</MenuItem>
                <MenuItem value="2">Kwong</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                displayEmpty
                variant="outlined"
              >
                <MenuItem value="allCases">All Cases</MenuItem>
                <MenuItem value="highCases">High Value Cases</MenuItem>
                <MenuItem value="riskCases">At Risk Cases</MenuItem>
                <MenuItem value="aiRecommendations">AI Recommendations</MenuItem>
              </Select>
            </FormControl>

            <FormControlLabel
              control={<Checkbox size="small" defaultChecked />}
              label={<Typography variant="body2">AI Recommendations</Typography>}
              sx={{ m: 0 }}
            />
            <FormControlLabel
              control={<Checkbox size="small" />}
              label={<Typography variant="body2">Blocked Cases</Typography>}
              sx={{ m: 0 }}
            />
          </Stack> */}

        {/* Notifications */}
        {/* <IconButton color="inherit">
            <Badge badgeContent={4} color="error">
              <NotificationsIcon color="action" />
            </Badge>
          </IconButton>
        </Stack> */}

      </Toolbar>
    </AppBar>
  );
};

export default Header;